<template lang="html">
  <div class="geo-drpdown-list__wrapper">

    <div class="geo-drpdown-list__items">
      <geo-checkboxes
        v-for="item in options"
        v-model="tags"
        :value="item"
        :label="item.text"
        :key="item.key"
        class="geo-drpdown-list__item"
      >
      </geo-checkboxes>
    </div>

    <div class="geo-drpdown-list-buttons">
      <a href="#" class="button button--wayra geo-drpdown-list__save" @click="save">Сохранить</a>
      <a href="#" class="button geo-drpdown-list__clear" @click.prevent="clearList">Очистить</a>
    </div>

  </div>
</template>

<script>

  import geoCheckboxes from './geo-checkbox'

  import uniqBy from 'lodash/uniqBy'
  import isEqual from 'lodash/isEqual'
  import each from 'lodash/forEach'
  // import intersectionBy from 'lodash/intersectionBy'
  import intersectionWith from 'lodash/intersectionWith'
  import pullAllWith from 'lodash/pullAllWith'

  export default {
    name: 'geoCheckboxesList',
    components: {
      geoCheckboxes,
    },
    model: {
      prop: 'modelValue',
      event: 'input'
    },
    props: {
      options: {
        type: Array,
        default: null,
      },
      label: {
        default: null,
      },
      modelValue: {
        default:  function () { return [] }
      }
    },

    methods:{
      clearList(){
        let modelValue = this.modelValue.slice(0);
        let checkedObj = intersectionWith(this.options.slice(0), modelValue, isEqual);

        if (checkedObj.length) {
          pullAllWith(modelValue, checkedObj, isEqual)
          this.$emit('input', modelValue)
        }
      },

      toggleList(){
        this.showList = !this.showList
      },

      save(){
        // this.toggleList()
        // this.$parent.autocompleteUnsetFocus()
        // this.$parent.autocompleteFocused = false;
        if (typeof unlockScreen == 'function') {
          unlockScreen();
        }
        this.$emit('unFocus')
      }


    },

    watch: {
      modelValue(newValue, oldValue) {
        if (!isEqual(newValue, oldValue)) {
          this.tags = this.modelValue;
        }
      },
    },

    data() {
      return {
        showList: false
      }
    },

    computed: {
      tags: {
        get: function () {
          return this.modelValue;
        },
        set: function (newValue) {
          this.$emit('input', uniqBy(newValue, 'text'))
        }
      }
    },
    mounted() {
      this.tags = this.modelValue;
    },

  }
</script>

<style lang="scss">

@import './../../../../../../_2017/dk/www/html/css/scss/breakpoints';

  .geo-drpdown-list__items{
    // display: flex;
    // flex-direction: row;
    // flex-wrap: wrap;
    column-count: 2;
    padding: 0 10px;

    .b-vertical-filter &{
      column-count: auto;
    }

    @include breakpoint(large down) {
      column-count: auto;
    }

    label.geo-drpdown-list__item{
      // flex-basis: 50%;
      width: 100%;
      padding-top: 10px !important;
    }
  }

  .geo-drpdown-list-buttons{
      width: 100%;
      margin-top: 20px;
      margin-bottom: 20px;
      margin-left: 10px;
      .button{
        display: inline-block;
        vertical-align: middle;
      }
      .geo-drpdown-list__clear{
        border: 0;
      }
      .geo-drpdown-list__save{
        background: #ff6659;
        color: #fff;
        border-color: #ff6659;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/geo/geo-checkboxes-list.vue